import columns from './utils/columns'

const state = () => ({
  customReports: null,
  columns,

  reportId: null,
  reportName: null,
  subId: null,

  publisher: null,
  publishers: [],

  team: null,
  teams: {},

  currentRecord: {},

  publisherViewStatus: null,

  isLoadingPublisher: false,
  didLoadPublisherFail: false,

  isLoadingTeams: false,
  didLoadTeamsFail: false,
})

export default state
